<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
// import TableListDescription from "./components/table-list-description.vue";
import ModalFormConfig from "./components/modal-form-config.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    // TableListDescription,
    ModalFormConfig,
  },

  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
			{ width: "50px", label: "No", name: "-" },

			{ width: "auto", label: "Indikator", name: "indikator" },
			{ width: "auto", label: "Bobot", name: "bobot" },
			{ width: "auto", label: "Status", name: "is_active" },
	

			{ width: "200px", label: "Aksi", name: "-" }
		];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Master Proctor Config",
      isStoreConfigProctor: false,

      totalBobot: 0,
      loadingTotalBobot: false,

      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idconfig_proctoring", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableDataFilter: {
        draw: 0,
        page:1,
        per_page: 10,
        search: "",
        column: 'idconfig_proctoring',
        dir: "asc",
        indikator: "",
        bobot: "",
        is_active: "",
        filter_status: "all", // untuk filtering data
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      configState: {
        audio: {
          label: 'Noise',
          status: false,
        },
        numHumans: {
          label: 'Multiple Faces',
          status: false,
        },
        tabSwitch: {
          label: 'Tab Switch',
          status: false,
        },
        detectMultipleScreens: {
          label: 'Multiple Monitors',
          status: false,
        },
        photosAtRandom: {
          label: 'Random Photos',
          status: false,
        },
        forceFullScreen: {
          label: 'Enforce Full Screen',
          status: false,
        },
      },
    };
  },

  mounted() {
    this.getConfigProctor();
    this.getDataTable();
    this.getTotalBobot();
  },

  methods: {
    getConfigProctor() {
      Swal.fire({
        title: 'Loading...',
        text: 'Sedang mengambil data config',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      axios({
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/config-proctoring",
        method: 'get',
        // data: this.configState,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        let meta = res?.data?.meta;
        if(meta?.code == 200){
          let data = res?.data?.data || [];
          const mapping = {
            'noise-detected': 'audio',
            'no-face-looking-at-camera': 'numHumans',
            'tab-focus-lost': 'tabSwitch',
            'multiple-monitors': 'detectMultipleScreens',
            'random-photo-taken': 'photosAtRandom',
            'fullscreen-exited': 'forceFullScreen',
          };

          data.forEach(item => {
            const stateKey = mapping[item.label];
            if (stateKey && this.configState[stateKey]) {
              this.configState[stateKey].status = item.is_active == 1;
            }

          });

        } else {
          Swal.fire('Peringatan', 'Terdapat kendala saat mengambil data config', 'warning');
        }
      }).catch((err) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Terjadi kesalahan pada sistem',
          showConfirmButton: true,
        });
      }).finally(() => {
        Swal.close();
      })
    },

    getDataTable(resetPage = true) {
      this.tableDataFilter.page = resetPage ? 1 : this.tableDataFilter.page;
      let self = this;
      self.loadingTable = true;
      self.tableDataFilter.draw++;

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/config-proctoring/getDataTable",
        params: self.tableDataFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            console.log(response_data_fix);
            self.table_data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.currentTablePage = response_data_fix.current_page;
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableDataFilter.column = key;
      this.tableDataFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableDataFilter.page = link.get("page");
      // this.tableDataFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },

    getTotalBobot() {
      this.loadingTotalBobot = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/config-proctoring/total-bobot",
        method: "get",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          if (res?.data?.meta?.code == 200) {
            console.log(res);
            this.totalBobot = Number(res?.data?.data?.data) || 0;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loadingTotalBobot = false;
        });
    },

    onStored() {
      this.getDataTable();
      this.getTotalBobot();
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <ModalFormConfig ref="modalForm" @stored="onStored" />

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <h6 class="fw-semibold mb-2">Total Bobot</h6>
            <div v-if="loadingTotalBobot" class="text-center py-2">
              <i class="fas fa-spinner fa-spin"></i> Memuat...
            </div>
            <template v-else>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">0%</span>
                <span
                  class="fw-bold"
                  :class="{
                    'text-success': totalBobot <= 50,
                    'text-warning': totalBobot > 50 && totalBobot <= 80,
                    'text-danger': totalBobot > 80,
                  }"
                >{{ totalBobot }}%</span>
                <span class="text-muted small">100%</span>
              </div>
              <div class="progress" style="height: 18px; border-radius: 9px;">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: totalBobot + '%' }"
                  :class="{
                    'bg-success': totalBobot <= 50,
                    'bg-warning': totalBobot > 50 && totalBobot <= 80,
                    'bg-danger': totalBobot > 80,
                  }"
                  :aria-valuenow="totalBobot"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <div class="mt-1 small" :class="totalBobot >= 100 ? 'text-danger fw-semibold' : 'text-muted'">
                {{ totalBobot >= 100 ? 'Bobot sudah penuh (100%)' : `Sisa bobot tersedia: ${100 - totalBobot}%` }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 d-flex justify-content-end mb-2">
            <!-- <b-button variant="primary" size="sm" @click="$refs.modalForm.open()">
              <i class="fa fa-plus me-1"></i> Tambah Data
            </b-button> -->
          </div>
          <div class="col-12">
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="99" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="!table_data || table_data.length === 0" class="text-center">
                  <td class="text-center" colspan="99">
                    Data Tidak Tersedia
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="row_data.idconfig_proctoring"
                >
                  <td class="text-center">
                    {{ (currentTablePage - 1) * (tableDataFilter.per_page || 10) + key_data + 1 }}
                  </td>
                  <td class="text-center">{{ row_data.indikator }}</td>
                  <td class="text-center">{{ row_data.bobot || '0' }}%</td>
                  <td class="text-center ">
                    <span class="d-block text-nowrap badge bg-success py-2" v-if="row_data.is_active == 1">Aktif</span>
                    <span class="d-block text-nowrap badge bg-secondary py-2" v-else>Tidak Aktif</span>
                  </td>
                  <td class="text-center">
                    <div class="btn-group btn-group-sm">
                      <button
                        class="btn btn-warning btn-sm"
                        @click="$refs.modalForm.open(row_data)"
                      >
                        <i class="fa fa-edit"></i> Edit
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
          </div>
          <pagination :pagination="pagination" @to-page="toPage"></pagination>
        </div>
      </div>
    </div>

    <!-- table list deskripsi -->
    <!-- <div class="card">
      <div class="card-body">
				<div class="row">
					<div class="col-12">
            <h4 class="mym-title-header mb-3 d-flex align-items-center">
              Deskripsi<i class="fa fa-info-circle text-primary fw-bold ms-1"></i>
              <b-button
                type="button"
                size="sm"
                class="opacity-0"
              >
                <i class="fa fa-info me-1"></i>
              </b-button>
            </h4>						
            
            <tableListDescription />
					</div>
				</div>
      </div>
    </div> -->
  </Layout>
</template>